import { useState } from "react";
import { notifications } from "@mantine/notifications";
import {
  Button,
  Group,
  LoadingOverlay,
  Paper,
  Stack,
  Text,
  ThemeIcon,
  Tooltip,
} from "@mantine/core";
import { useLanguage } from "../../../../../../stores/LanguageStore";
import {
  IconAutomation,
  IconClock,
  IconClockCheck,
  IconSwitchHorizontal,
} from "@tabler/icons-react";
import ItemDeleter from "../../../../../../components/TableComponents/ItemDeleter";
import { parseDate } from "../../../../../../functions/dates";
import { deleteCron, executeCron } from "../../../../../../api/ConfigsApi";
import CronActivator from "../CronActivator";
import EditPrmCron from "./EditPrmCron";

const PrmCronItem = ({ item, handleReload }) => {
  const lang = useLanguage((s) => s.language);
  const [loading, setLoading] = useState(null);

  const handleSend = () => {
    setLoading("send");
    executeCron({ id: item?.id })
      .then(() => {
        notifications.show({
          message: lang.contact_lists.cron.cron_launched,
          color: "tertiary.8",
        });
        handleReload();
      })
      .finally(() => setLoading(false));
  };

  return (
    <Paper component={Stack} withBorder p={"sm"} pos={"relative"} w={"32%"}>
      <LoadingOverlay visible={loading} />
      <Group wrap="nowrap">
        <ThemeIcon color="black">
          <IconAutomation />
        </ThemeIcon>
        <Text size="lg">{item.name}</Text>

        <CronActivator item={item} setLoading={setLoading} />
      </Group>

      <Text>
        {lang.sync_zapier.event_label} :{" "}
        {lang.sync_zapier.frequency[item.frequency]}
      </Text>

      <Group>
        <Group mr={8} miw={150}>
          <Tooltip label={lang.sync_zapier.last_run}>
            <IconClock size={18} />
          </Tooltip>
          <Text size="sm">{item?.ran_at ? parseDate(item?.ran_at) : "-"}</Text>
        </Group>

        <Group mr={8}>
          <Tooltip label={lang.contact_lists.cron.execution_time}>
            <IconClockCheck size={18} />
          </Tooltip>
          <Text size="sm">
            {item?.execution_time_seconds
              ? `${item?.execution_time_seconds}s`
              : "-"}
          </Text>
        </Group>
      </Group>

      <Group>
        <Button
          loading={loading === "send"}
          variant="filled"
          loadingPosition="center"
          leftSection={<IconSwitchHorizontal size={18} />}
          onClick={handleSend}
        >
          {lang.sync_zapier.send}
        </Button>

        <EditPrmCron item={item} handleDone={handleReload} />

        <ItemDeleter
          deletedMessage={lang.sync_zapier.delete_success}
          title_bold={`${item.name} #${item.id}`}
          handleDelete={deleteCron}
          id={item.id}
          onFinish={() => handleReload()}
        />
      </Group>
    </Paper>
  );
};

export default PrmCronItem;
